import _ from 'lodash';
import { dateStringToMonth } from 'routes/HumanResourcesModule/business/helpers';
import { DateString } from 'routes/HumanResourcesModule/business/types';

export const getChangedValuesByDates = (
    newValuesByDates: Record<DateString, number>,
    oldValuesByDates: Record<DateString, number>,
): Record<string, number> => {
    const changedValuesByDates: Record<DateString, number> = _.pickBy(
        newValuesByDates,
        (value, key: DateString) =>
            !_.has(oldValuesByDates, key) || oldValuesByDates[key] !== value,
    );

    return _.mapKeys(changedValuesByDates, (v, k: DateString) =>
        dateStringToMonth(k),
    );
};
